import { render, staticRenderFns } from "./BotaoDownload.vue?vue&type=template&id=374c6f15&scoped=true"
import script from "./BotaoDownload.vue?vue&type=script&lang=js"
export * from "./BotaoDownload.vue?vue&type=script&lang=js"
import style0 from "./BotaoDownload.vue?vue&type=style&index=0&id=374c6f15&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c6f15",
  null
  
)

export default component.exports